import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Wrapper around figtree's built-in /json/v1/service/* endpoints —
 * exposes the running ServiceManager state and lets admins start,
 * stop and ad-hoc invoke any registered service.
 */
export class Service {
    static async getStatus() {
        var _a;
        const result = await NetFetch.getData('/json/v1/service/status');
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = (result.services)) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
    static async invoke(name) {
        const result = await NetFetch.postData('/json/v1/service/invoke', { name });
        return Service._isOk(result);
    }
    static async start(name) {
        const result = await NetFetch.postData('/json/v1/service/start', { name });
        return Service._isOk(result);
    }
    static async stop(name) {
        const result = await NetFetch.postData('/json/v1/service/stop', { name });
        return Service._isOk(result);
    }
    static _isOk(result) {
        if (!result || !result.statusCode) {
            return false;
        }
        switch (result.statusCode) {
            case StatusCodes.OK:
                return true;
            case StatusCodes.UNAUTHORIZED:
                throw new UnauthorizedError();
            default:
                if (result.msg) {
                    throw new Error(result.msg);
                }
                return false;
        }
    }
}
